module.exports = __webpack_public_path__ + "static/pokupka-c44d049a9230990dd9acaf9259917e1c.png";